import { useMemo } from 'react'
import { useSelector, shallowEqual } from 'react-redux'

import { DetailsGroup, useReportDetailsGroup } from './useReportDetailsGroup'


export type SummaryDto = {
  totalPersonal: number
  totalCommon: number
  total: number
}

export function useReportSummaryDto() {
  const summary = useSelector((state: any) => state.reports.subsidies.data.summary, shallowEqual)
  const detailsGroup = useReportDetailsGroup()

  const res = useMemo(() => {
    if (detailsGroup === DetailsGroup.NoGroup && summary) {
      const { total, total_common: totalCommon, total_personal: totalPersonal } = summary
      return { total, totalCommon, totalPersonal } as SummaryDto
    }
    return null
  }, [summary, detailsGroup])

  return res
}
